import { render, staticRenderFns } from "./Welcome_screen.vue?vue&type=template&id=d2ff581c&scoped=true"
import script from "./Welcome_screen.vue?vue&type=script&lang=js"
export * from "./Welcome_screen.vue?vue&type=script&lang=js"
import style0 from "./Welcome_screen.vue?vue&type=style&index=0&id=d2ff581c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ff581c",
  null
  
)

export default component.exports